import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Button,
  Input,
  Form,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import Select from 'react-select';
import CsLineIcons from '../../../cs-line-icons/CsLineIcons';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { fetchUserRoleLists } from '../action/action';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Link, useHistory } from 'react-router-dom';
import { CreateNewUser } from '../action/action';
import { SORTING_ORDER } from '../../../constants/index';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import toast, { Toaster } from 'react-hot-toast';
import { getUserRoleLists } from '../../../Redux/permissions/permissionsSlice';
import { fetchUserRolemaster } from '../action/action';
import { fetchUserView } from '../action/action';
import { getEditDetailList } from '../action/action';
import { useParams } from 'react-router-dom';
import { getUserEdit } from '../../../Redux/permissions/permissionsSlice';

//Import Breadcrumb
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import classnames from 'classnames';

const EditUserForm = () => {
  const dispatch = useDispatch();
  const [activeDate, setActiveDate] = useState();
  const [activeValue, setActiveValue] = useState();
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [getCountry, setCountryList] = useState([]);
  const { id } = useParams();

  const [verticalActiveTab, setverticalActiveTab] = useState('1');

  const [headerTab, setHeaderTab] = useState('1');
  const [headerPillsTab, setHeaderPillsTab] = useState('1');
  const history = useHistory();

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };
  let UserRoleID = '';
  let UserID = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserID = userObj?.user_id;
    }
  }

  useEffect(() => {
    fetchUserRolemaster({
      params: {
        role_id: UserRoleID,
      },
      dispatch,
    });
  }, []);

  const { UserRoleMaster = [], isLoadingMaster } = useSelector(
    (state) => state.permissions
  );
  const orderData = UserRoleMaster?.Data;
  useEffect(() => {
    fetchUserView({
      params: {
        userid: id,
      },
      dispatch,
    });
  }, []);
  const { UserView = [], isLoadingView } = useSelector(
    (state) => state.permissions
  );
  const UserViewList = UserView?.message;

  const [newRole, setPlacedNewRole] = useState('');

  const optionMulti = [
    { label: 'UAE', value: 'ae' },
    { label: 'Bahrain', value: 'bh' },
    { label: 'Oman', value: 'om' },
    { label: 'Kuwait', value: 'kw' },
    { label: 'Qatar', value: 'qa' },
    { label: 'All', value: 'All' },
  ];
  let contrySelect = [];
  useEffect(() => {
    if (UserViewList !== undefined) {
      const countryArr = UserViewList?.country.split(',');
      //setCountryList(countryArr);

      if (countryArr.includes('ae') || countryArr.includes('AE')) {
        setCountryList((oldArray) => [...oldArray, optionMulti[0]]);
      }
      if (countryArr.includes('om') || countryArr.includes('OM')) {
        setCountryList((oldArray) => [...oldArray, optionMulti[2]]);
      }
      if (countryArr.includes('bh') || countryArr.includes('BH')) {
        setCountryList((oldArray) => [...oldArray, optionMulti[1]]);
      }
      if (countryArr.includes('kw') || countryArr.includes('KW')) {
        setCountryList((oldArray) => [...oldArray, optionMulti[3]]);
      }
      if (countryArr.includes('qa') || countryArr.includes('QA')) {
        setCountryList((oldArray) => [...oldArray, optionMulti[4]]);
      }
      if (countryArr.includes('All') || countryArr.includes('all')) {
        setCountryList([optionMulti[5]]);
      }
      /*  if(countryArr.length > 0)
  { */
      //setCountryList([optionMulti[0],optionMulti[1]]);

      // }
    }
  }, [UserViewList]);

  const handleEditUser = (events, values) => {
    const firstname = values?.firstname ? values?.firstname : '';
    const lastname = values?.lastname ? values?.lastname : '';
    const username = values?.username ? values?.username : '';
    const Userpass = values?.Userpass ? values?.Userpass : '';
    const password1 = values?.password1 ? values?.password1 : '';
    const is_active = values?.is_active ? values?.is_active : activeValue;
    const expirationdate = activeDate;
    const roleid = values?.role ? values?.role : newRole;
    const userCountry = [];
    if (selectedCountry?.length > 0) {
      selectedCountry?.map((selCountry) => {
        userCountry.push(selCountry?.value);
      });
    } else {
      getCountry?.map((getCountry) => {
        userCountry.push(getCountry?.value);
      });
    }

    const password = values?.password ? values?.password : '';
    getEditDetailList({
      params: {
        userid: id,
        firstname: firstname,
        lastname: lastname,
        username: username,
        country: userCountry,
        is_active: is_active,
        password: password,
        confirmpassword: password1,
        expirationdate: expirationdate,
        role_id: roleid,
        user_id: UserID,
        currentuserpass: Userpass,
      },
      dispatch,
    });
  };
  const { UserEdit = [], isLoadingEdit } = useSelector(
    (state) => state.permissions
  );

  useEffect(() => {
    if (UserEdit?.code === 100) {
      toast.success(UserEdit?.message, {
        style: {
          border: '1px solid #fff',
          padding: '20px',
          color: '#ffffff',
          background: '#4CAF50',
        },
        iconTheme: {
          primary: '#FFFAEE',
          secondary: '#4CAF50',
        },
      });
      setTimeout(() => {
        history.push('/permission');
      }, 10);
      dispatch(getUserEdit(null));
    } else {
      if (UserEdit?.message) {
        toast.error(UserEdit?.message, {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
        dispatch(getUserEdit(null));
      }
    }
  }, [UserEdit]);

  const handleCountryMultiSelection = (newselectedOptions) => {
    setSelectedCountry(newselectedOptions);
  };
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row style={{ marginTop: '6rem' }}>
            <Col>
              <DashBreadcrumb title="Users Detail" breadcrumbItem="User" />
            </Col>
          </Row>

          <Row>
            <Col>
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, v) => {
                  handleEditUser(e, v);
                }}
              >
                <Row>
                  <Col md="3">
                    <Card>
                      <Nav pills className="flex-column">
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                              'mb-2': true,
                              active: verticalActiveTab === '1',
                            })}
                            onClick={() => {
                              toggleVertical('1');
                            }}
                          >
                            User Info
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Card>
                  </Col>
                  <Col md="9">
                    <TabContent
                      activeTab={verticalActiveTab}
                      className="text-muted mt-4 mt-md-0"
                    >
                      <TabPane tabId="1">
                        <React.Fragment>
                          <Col xl={9}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom01">
                                        First name
                                      </Label>
                                      <AvField
                                        name="firstname"
                                        placeholder="First name"
                                        type="text"
                                        value={UserViewList?.firstname}
                                        errorMessage="Enter First Name"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        id="validationCustom01"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom02">
                                        Last name
                                      </Label>
                                      <AvField
                                        name="lastname"
                                        value={UserViewList?.lastname}
                                        placeholder="Last name"
                                        type="text"
                                        className="form-control"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom03">
                                        Email
                                      </Label>
                                      <AvField
                                        name="email"
                                        value={UserViewList?.email}
                                        type="email"
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col lg="6">
                                    <FormGroup className="mb-3">
                                      <AvField
                                        type="select"
                                        name="is_active"
                                        label="This account is"
                                        className="form-select"
                                        onChange={(e) =>
                                          setActiveValue(e.target.value)
                                        }
                                        value={UserViewList?.Isactive}
                                      >
                                        <option value="">Select</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom04">
                                        Password
                                      </Label>
                                      <AvField
                                        name="password"
                                        type="password"
                                        value={UserViewList?.password}
                                        placeholder="Password"
                                        errorMessage="Enter password"
                                        validate={{ required: { value: true } }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom04">
                                        Confirmed password
                                      </Label>
                                      <AvField
                                        name="password1"
                                        type="password"
                                        value={UserViewList?.password}
                                        placeholder="Re-type Password"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md="6">
                                    <Label>Associate to Website</Label>

                                    {getCountry.length > 0 ? (
                                      <Select
                                        defaultValue={getCountry}
                                        isMulti
                                        name="country"
                                        options={optionMulti}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        onChange={(value) =>
                                          handleCountryMultiSelection(value)
                                        }
                                      />
                                    ) : (
                                      <>
                                        <Select
                                          isMulti
                                          name="country"
                                          options={optionMulti}
                                          className="basic-multi-select"
                                          classNamePrefix="select"
                                          onChange={(value) =>
                                            handleCountryMultiSelection(value)
                                          }
                                        />
                                      </>
                                    )}
                                  </Col>
                                  <Col lg="6">
                                    <AvField
                                      type="select"
                                      name="role"
                                      label="User Role*"
                                      className="form-select"
                                      onChange={(e) =>
                                        setPlacedNewRole(e.target.value)
                                      }
                                      value={UserViewList?.role_id}
                                      required
                                    >
                                      <option>Select the Role</option>
                                      {orderData?.map((ele, im) => (
                                        <option value={ele.role_id} key={im}>
                                          {ele.role_name}
                                        </option>
                                      ))}
                                    </AvField>
                                  </Col>
                                </Row>
                                <Row className="mt-3">
                                  <Col lg="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="validationCustom04">
                                        Current User Identity Verification
                                      </Label>
                                      <AvField
                                        name="Userpass"
                                        type="password"
                                        placeholder="Password"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Button color="dark" type="submit">
                                  Save User
                                </Button>
                              </CardBody>
                            </Card>
                          </Col>
                        </React.Fragment>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </AvForm>
            </Col>
          </Row>
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default EditUserForm;
